import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import NewsBox from '../NewsBox';
import NewsBoxSkeleton from "../../Skeleton/NewsBoxSkeleton";

import { getImageBannerQuery } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './ImageBanner.css';
import l from '../../Skeleton/Skeleton.css';

const ImageBanner = ({ getImageBannerData }) => {

  const isLoading = getImageBannerData?.loading;
  const bannerData = getImageBannerData?.getImageBanner;

  return (
    <>
      {isLoading ? (
        <div className={s.pageContainer}>
          <div className={s.container}>
            <NewsBoxSkeleton />
          </div>
        </div>
      ) : (
        <div className={s.pageContainer}>
          <div className={s.container}>
            <NewsBox data={bannerData} />
          </div>
        </div>
      )}
    </>
  );
};

ImageBanner.propTypes = {
  getImageBannerData: PropTypes.shape({
    loading: PropTypes.bool,
    getImageBanner: PropTypes.object
  }),
};

ImageBanner.defaultProps = {
  getImageBannerData: {
    loading: true
  },
};

export default compose(
  injectIntl,
  withStyles(s, l),
  withQuery(getImageBannerQuery, {
    name: 'getImageBannerData',
    options: {
      ssr: false
    }
  }),
)(ImageBanner);
